import "unpoly/unpoly.js"
import "unpoly/unpoly.css"

import Helpers from "@/unpoly/helpers"

import UnpolyBootstrap from "@/unpoly/bootstrap"
import UnpolyReact from "@/unpoly/react"
import UnpolyPasswordToggle from "@/unpoly/passwordToggle"
import UnpolyPoll from "@/unpoly/poll"
import UnpolySidebarOrigin from "@/unpoly/sidebarOrigin"

const start = () => {
  Helpers.withUnpoly((up) => {
    up.log.config.banner = false
    up.fragment.config.runScripts = true

    UnpolyBootstrap.start({ up, modalSelector: ".global-modal-holder" })
    UnpolyReact.start({ up })
    UnpolyPasswordToggle.start()
    UnpolyPoll.start({ up })
    UnpolySidebarOrigin.start({ up })

    /**
     *  Booting is disabled through the following line in our main layout
     *    = javascript_pack_tag 'unpoly_application', "up-boot" => "manual"
     *
     *  Seeing
     *    Call up.boot() after you have configured Unpoly
     *
     *  is normal.
     *
     *  Unpoly *always* prints this out when manual boot is in effect.
     */
    // Packs load without `defer` (see layouts/_head), so this runs while the
    // document is still parsing — boot must wait for the DOM or up.boot()
    // compiles an empty body.
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => up.boot())
    } else {
      up.boot()
    }
  })
}

export default { start }
